// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PriceFromJSON, PriceToJSON, } from './';
export function PmiPricesAllOfFromJSON(json) {
    return {
        'prices': !exists(json, 'prices') ? undefined : json['prices'].map(PriceFromJSON),
    };
}
export function PmiPricesAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'prices': value.prices === undefined ? undefined : value.prices.map(PriceToJSON),
    };
}
